<script setup>
  import { ref } from "vue";
  import ExploremoreLcCat from "./exploremore-lc-cat.vue";
  // import "@/styles/css/learning-center.scss";
  const view = ref(false);
  const openView = () => {
    view.value = true;
  };
</script>
<template>

  <div class="container-learning-center page-container" style="margin-top: 70px;">
    <section class="lc_completeToc">
      <section class="learning-center_banner">
        <div class="visible-lg visible-md visible-sm">
          <picture>
            <source srcset="
              https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-trading-account.webp
            " type="image/webp" />
            <img title="Trading Account" alt="trading account"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-trading-account.png" />
          </picture>
        </div>
        <div class="visible-xs">
          <picture>
            <source srcset="
              https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-trading-account-mobile.webp
            " type="image/webp" />
            <img alt="trading account"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-trading-account-mobile.png" />
          </picture>
        </div>
      </section>

      <section class="toc_container LC-article">
        <div class="container-fluid ht-page faq">
          <div class="">
            <div class="lc-cat-toc-wraper">
              <h1 class="curr-tax">Trading Account</h1>
              <br />
              <p class="curr-tax-desc">
                Understand what is a trading account and how you can become an
                efficient trader.
              </p>
            </div>
            <div class="lc-cat-toc-wraper">
              <p class="toc-txt">TABLE OF CONTENTS</p>
              <ul class="lc-category-page-wrapper hidden-md hidden-lg">
                <li class="LC-toc-list">
                  <h2>
                    <a id="1" href="/learning-center/trading-account/insider-trading-legal-or-illegal-in-india/">Insider
                      Trading in India: Understanding the Legal
                      Framework</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="2" href="/learning-center/trading-account/trading-account-is-which-type-of-account/">Trading
                      Account is Which Type of Account</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="3"
                      href="/learning-center/trading-account/what-is-gross-profit-how-to-calculate-gross-profit/">Gross
                      Profit - Formula, Ratio, Meaning, Net Profit, Margin,
                      &amp; How to Calculate</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="4" href="/learning-center/trading-account/how-to-open-trading-account-online/">How To Open
                      Trading Account Online?</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="5" href="/learning-center/trading-account/how-to-open-a-commodity-trading-account/">How to
                      Open a Commodity Trading Account</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="6" href="/learning-center/trading-account/what-is-swing-trading/">What is Swing Trading for
                      Beginners - Strategies, Meaning,
                      Indicators, &amp; How to Do</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="7"
                      href="/learning-center/trading-account/buy-today-and-sell-tomorrow-btst-trading-strategy/">Buy
                      Today and Sell Tomorrow (BTST) Trading Strategy</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="8" href="/learning-center/trading-account/what-is-commodity-market/">Commodity Market Trading
                      For Beginners &amp; How to Trade
                      in India - Strategy &amp; Meaning</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="9"
                      href="/learning-center/trading-account/what-is-commodity-trading-overview-benefits-of-investing/">What
                      is Commodity Trading: Overview &amp; Benefits of
                      Investing</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="10"
                      href="/learning-center/trading-account/what-is-forex-trading-strategies-for-beginners-in-india/">What
                      Is Forex Trading for Beginners in India - Strategies,
                      Platform, Meaning, &amp; How to Start</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="11" href="/learning-center/trading-account/what-is-trading-on-equity/">What Is Trading on
                      Equity?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="12"
                      href="/learning-center/trading-account/trading-and-profit-and-loss-account-definition-types-example/">Trading,
                      Profit And Loss Account: Definition, Types,
                      Example</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="13" href="/learning-center/trading-account/trading-account-format/">Trading Account Format:
                      Examples &amp; Advantages</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="14" href="/learning-center/trading-account/what-is-insider-trading/">What Is Insider Trading
                      in India - Meaning, Regulations,
                      Examples, &amp; Types</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="15" href="/learning-center/trading-account/creating-a-commodity-trading-plan/">How to Create
                      a Commodity Trading Business Plan</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="16"
                      href="/learning-center/trading-account/what-is-the-meaning-of-credit-balance-of-trading-account/">What
                      is the meaning of credit balance of trading
                      account?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="17"
                      href="/learning-center/trading-account/importance-of-a-trading-account-and-why-you-need-it/">Importance
                      of a trading account, and why you need it</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="18" href="/learning-center/trading-account/types-of-trading-accounts/">Types of trading
                      accounts</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="19"
                      href="/learning-center/trading-account/features-and-benefits-of-a-trading-account/">Features and
                      benefits of a trading account</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="20"
                      href="/learning-center/trading-account/account-opening-form-for-a-trading-account/">Account
                      opening form for a trading account</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="21" href="/learning-center/trading-account/how-to-trade-using-a-trading-account/">How to
                      trade using a trading account</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="22"
                      href="/learning-center/trading-account/documents-required-to-open-a-trading-account/">Documents
                      required to open a trading account</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="23" href="/learning-center/trading-account/trading-account-opening-procedure/">Trading
                      account opening procedure</a>
                  </h2>
                </li>
                <!-- <div id="showall-posts">Show All</div> -->
                <!-- <div class="scroll-down" id="scroll-d">
                <img
                  alt="Scroll Down"
                  src="https://upstox.com/app/themes/upstox/dist/img/learning_center/scroll.png"
                />
              </div> -->
              </ul>
              <ul class="lc-category-page-wrapper hidden-xs hidden-sm">
                <li class="LC-toc-list">
                  <h2>
                    <a id="1" href="/learning-center/trading-account/insider-trading-legal-or-illegal-in-india/">
                      Insider Trading in India: Understanding the Legal Framework
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="2" href="/learning-center/trading-account/trading-account-is-which-type-of-account/">
                      Trading Account is Which Type of Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="3"
                      href="/learning-center/trading-account/what-is-gross-profit-how-to-calculate-gross-profit/">
                      Gross Profit - Formula, Ratio, Meaning, Net Profit, Margin,
                      &amp; How to Calculate
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="4" href="/learning-center/trading-account/how-to-open-trading-account-online/">
                      How To Open Trading Account Online?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="5" href="/learning-center/trading-account/how-to-open-a-commodity-trading-account/">
                      How to Open a Commodity Trading Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="6" href="/learning-center/trading-account/what-is-swing-trading/">
                      What is Swing Trading for Beginners - Strategies, Meaning,
                      Indicators, &amp; How to Do
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="7"
                      href="/learning-center/trading-account/buy-today-and-sell-tomorrow-btst-trading-strategy/">
                      Buy Today and Sell Tomorrow (BTST) Trading Strategy
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="8" href="/learning-center/trading-account/what-is-commodity-market/">
                      Commodity Market Trading For Beginners &amp; How to Trade in
                      India - Strategy &amp; Meaning
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="9"
                      href="/learning-center/trading-account/what-is-commodity-trading-overview-benefits-of-investing/">
                      What is Commodity Trading: Overview &amp; Benefits of
                      Investing
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="10"
                      href="/learning-center/trading-account/what-is-forex-trading-strategies-for-beginners-in-india/">
                      What Is Forex Trading for Beginners in India - Strategies,
                      Platform, Meaning, &amp; How to Start
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="11" href="/learning-center/trading-account/what-is-trading-on-equity/">
                      What Is Trading on Equity?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="12"
                      href="/learning-center/trading-account/trading-and-profit-and-loss-account-definition-types-example/">
                      Trading, Profit And Loss Account: Definition, Types, Example
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="13" href="/learning-center/trading-account/trading-account-format/">
                      Trading Account Format: Examples &amp; Advantages
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="14" href="/learning-center/trading-account/what-is-insider-trading/">
                      What Is Insider Trading in India - Meaning, Regulations,
                      Examples, &amp; Types
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="15" href="/learning-center/trading-account/creating-a-commodity-trading-plan/">
                      How to Create a Commodity Trading Business Plan
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="16"
                      href="/learning-center/trading-account/what-is-the-meaning-of-credit-balance-of-trading-account/">
                      What is the meaning of credit balance of trading account?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="17"
                      href="/learning-center/trading-account/importance-of-a-trading-account-and-why-you-need-it/">
                      Importance of a trading account, and why you need it
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="18" href="/learning-center/trading-account/types-of-trading-accounts/">
                      Types of trading accounts
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="19" href="/learning-center/trading-account/features-and-benefits-of-a-trading-account/">
                      Features and benefits of a trading account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="20" href="/learning-center/trading-account/account-opening-form-for-a-trading-account/">
                      Account opening form for a trading account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="21" href="/learning-center/trading-account/how-to-trade-using-a-trading-account/">
                      How to trade using a trading account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="22" href="/learning-center/trading-account/documents-required-to-open-a-trading-account/">
                      Documents required to open a trading account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="23" href="/learning-center/trading-account/trading-account-opening-procedure/">
                      Trading account opening procedure
                    </a>
                  </h2>
                </li>
                <!-- <div id="showall-posts">Show All</div> -->
              </ul>
            </div>
          </div>
          <div class="lc-toc-container"></div>
        </div>
      </section>
      <div id="showall-article" class="showall-article hidden-md hidden-lg">
        Table of contents
      </div>
    </section>
    <exploremoreLcCat></exploremoreLcCat>
  </div>
</template>
<style scoped>
</style>